<template>
    <div class="query-editor">
        <!-- <div>
            <v-row>
                <v-col cols="9">
                    <slot />
                </v-col>
                <v-col cols="3">
                    <v-btn v-if="readonly == false" style="margin-bottom: -30px;" :disabled="!to_analyze" text :color="to_analyze?'primary':'lightgrey'" @click="parse">
                        <v-icon class="mr-2">mdi-magnify</v-icon>
                        Analizza
                    </v-btn>
                </v-col>
            </v-row>
        </div> -->
        <v-row style="margin-top: -20px">
            <v-col>
                <datalist>
                    <option v-for="(option, i) in tooltip_options" :key="i" :data-name="option" data-icon="code" @contextmenu="tooltipSelect(option)" />
                </datalist>
                <p class="query-editor-text" :contenteditable="readonly == true ? 'false': 'true'" spellcheck="false" @input="markInput(true)" @paste="parse_paste" ref="p" />
            </v-col>
             <v-col cols="2">
                    <v-btn v-if="readonly == false" style="margin-bottom: -30px; margin-left: -20px;" :disabled="!to_analyze" text :color="to_analyze?'primary':'lightgrey'" @click="parse">
                        <v-icon class="mr-2">mdi-magnify</v-icon>
                        Analizza
                    </v-btn>
                </v-col>
        </v-row>
    </div>
</template>
<script>
import QueryParser from "./QueryParser.js";
export default {
    name: "QueryEditor",
    props: {
        emit_back : {
            type: Boolean,
            default : false
        },
        readonly : {
            type: Boolean,
            default : false
        },
        query_field: { 
            type: String, 
            default: 'query' 
        },
        tooltip_options : { 
            type: [Array, null], 
            default: null 
        },
        value: { 
            type: Object, 
            default: () => {} 
        },
        template: { 
            type: Array, 
            default: () => [] 
        },
    },
    data() {
        return {
            to_analyze : false,
        };
    },
    methods: {
        parse_paste(event) {
            event.preventDefault();
            const text = event.clipboardData.getData('text/plain');
            let selection = window.getSelection();
            let node = selection.anchorNode;
            if(node == this.$refs.p){
                node = document.createTextNode('');
                this.$refs.p.appendChild(node);
            }
            selection.getRangeAt(0).deleteContents();
            const original = node.textContent;

            const offset = selection.anchorOffset;
            const slice = original.substring(0, offset);
            node.textContent = slice + text + original.substring(offset);

            selection = window.getSelection();
            const range = document.createRange();
            const length = slice.length + text.length;
            range.setStart(node, length);
            range.setEnd(node, length);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
            this.markInput(true);
        },
        markInput(status){
            this.to_analyze = status;
            this.$emit('analyze', status);            
        },
        parse() {
            const textarea = this.$refs.p;

            const indents = textarea.getElementsByClassName('space');
            for (let i = 0; i < indents.length; i++) {
                indents[i].parentElement.removeChild(indents[i]);
            }

            const parsed_data = QueryParser.parse(textarea.innerText.toString(), this.template );

            const newdata = this.value;
            for (let i = 0; i < this.template.length; i++) {
                let newtable = [];
                let target = this.value[this.template[i].targetField];
                if (target === null) {
                    continue;
                }
                let oldtable = target == undefined ? [] : target.map((x) => x);
                let targetProperty = this.template[i].targetProperty;
                let parsed = parsed_data.found_symbols[this.template[i].keyword];
                if (parsed == null) {
                    parsed = new Array();
                }
                for (let j = 0; j < parsed.length; j++) {
                    let found = false;
                    for (let k = 0; k < oldtable.length; k++) {
                        let olditem = oldtable[k];
                        if (olditem == null) {
                            continue;
                        }
                        if (olditem[targetProperty] == parsed[j]) {
                            found = true;
                            newtable.push(olditem);
                            oldtable[k] = null;
                            break;
                        }
                    }
                    if (!found) {
                        const item_template =
                        this.template[i].getTemplate != null ? this.template[i].getTemplate(this.value, parsed[j]) : this.template[i].template;
                        let newitem = Object.assign({}, item_template);
                        newitem[targetProperty] = parsed[j];
                        newtable.push(newitem);
                    }
                }
                newdata[this.template[i].targetField] = newtable;
            }

            newdata[this.query_field] = parsed_data.clean_text.toString().replaceAll('\n', ' ').replaceAll('\t', ' ').replaceAll('\r', ' ');
            if(this.emit_back){
                this.$emit('input', { query: newdata[this.query_field] });
            }
            
            this.markInput(false);
            this.$refs.p.innerHTML = parsed_data.formatted_text;
        },
        tooltipSelect(text){
            let selection = window.getSelection();
            let node = selection.anchorNode;
            if(node == this.$refs.p){
                node = document.createTextNode("");
                this.$refs.p.appendChild(node);
            }
            selection.getRangeAt(0).deleteContents();
            const original = node.textContent;

            const offset = selection.anchorOffset;
            const slice = original.substring(0, offset);
            node.textContent = slice + text + original.substring(offset);

            selection = window.getSelection();
            const range = document.createRange();
            const length = slice.length + text.length;
            range.setStart(node, length);
            range.setEnd(node, length);
            range.collapse(true);
            selection.removeAllRanges();
            selection.addRange(range);
            this.markInput(true);
        },
    },
    watch : {
        value : {
            immediate: true,
            handler(value){
                if(!value){ return; }
                try{
                    this.$nextTick(() =>{
                        this.$refs.p.innerText = value[this.query_field];
                        this.parse();
                    });
                }catch(error){
                    console.error('Query parser error on value update: ' + error);
                }                                
            }
        }
    }
};
</script>
<style scoped>
.query-editor{
    position: relative;
    width:100%;
    height: 100%;
}
.query-editor > div{
    /* display: block; */
    margin: 0 auto 0px;
    text-align: right;
}
.query-editor-text {
  padding: 10px;
  outline: none !important;
  border-radius: 0;
  border: thin solid lightgrey;
  border-radius: 5px;
  /* resize: none; */
  width: 100%;
  font-size: 15px;
  margin: 10px auto 10px;
  text-align: left;
  min-height: calc(100vh - 170px);
  max-height: calc(100vh - 170px);
  overflow-y: auto;
  margin-bottom: -15px;
}
</style>
<style>
.query-editor-text::selection,
.query-editor-text *::selection {
  background-color: #1976d2;
  color: white;
}
.query-editor-text::-moz-selection,
.query-editor-text *::-moz-selection {
  background-color: #1976d2;
  color: white;
}
.query-editor-text mark {
  background-color: transparent;
  font-weight: 600;
}
.query-editor-text mark.keyword {
  text-transform: uppercase;
  color: #1976d2;
  font-weight: bold;
}
.query-editor-text mark.number {
  color: #ff3300;
}
.query-editor-text mark.text {
  color: #800000;
}
.query-editor-text mark.function {
  color: #cc0066;
}
.query-editor-text .space {
  padding-left: 20px;
}
</style>